// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistantsalesorder_positions_noellewarnings_notmultipleofve7 = /** @type {(inputs: { quantity: NonNullable<unknown>, packingQuantityVE: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The ordered quantity (${i?.quantity}) is not a multiple of the packing unit VE (${i?.packingQuantityVE}).`)
};

const en_us2_assistantsalesorder_positions_noellewarnings_notmultipleofve7 = /** @type {(inputs: { quantity: NonNullable<unknown>, packingQuantityVE: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The ordered quantity (${i?.quantity}) is not a multiple of the packing unit VE (${i?.packingQuantityVE}).`)
};

const de_de2_assistantsalesorder_positions_noellewarnings_notmultipleofve7 = /** @type {(inputs: { quantity: NonNullable<unknown>, packingQuantityVE: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die bestellte Menge (${i?.quantity}) ist kein Vielfaches der Verpackungseinheit VE (${i?.packingQuantityVE}).`)
};

const en_assistantsalesorder_positions_noellewarnings_notmultipleofve7 = /** @type {(inputs: { quantity: NonNullable<unknown>, packingQuantityVE: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The ordered quantity (${i?.quantity}) is not a multiple of the packing unit VE (${i?.packingQuantityVE}).`)
};

const de_assistantsalesorder_positions_noellewarnings_notmultipleofve7 = /** @type {(inputs: { quantity: NonNullable<unknown>, packingQuantityVE: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die bestellte Menge (${i?.quantity}) ist kein Vielfaches der Verpackungseinheit VE (${i?.packingQuantityVE}).`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ quantity: NonNullable<unknown>, packingQuantityVE: NonNullable<unknown> }} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistantsalesorder_positions_noellewarnings_notmultipleofve7 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistantsalesorder_positions_noellewarnings_notmultipleofve7(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistantsalesorder_positions_noellewarnings_notmultipleofve7", locale)
	if (locale === "en-GB") return en_gb2_assistantsalesorder_positions_noellewarnings_notmultipleofve7(inputs)
	if (locale === "en-US") return en_us2_assistantsalesorder_positions_noellewarnings_notmultipleofve7(inputs)
	if (locale === "de-DE") return de_de2_assistantsalesorder_positions_noellewarnings_notmultipleofve7(inputs)
	if (locale === "en") return en_assistantsalesorder_positions_noellewarnings_notmultipleofve7(inputs)
	return de_assistantsalesorder_positions_noellewarnings_notmultipleofve7(inputs)
};
export { assistantsalesorder_positions_noellewarnings_notmultipleofve7 as "assistantSalesOrder.positions.noelleWarnings.notMultipleOfVE" }